import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Compass, Home } from 'lucide-react';

/**
 * Page 404 — écran premium : gros numéro dégradé, halos décoratifs,
 * actions de navigation (accueil / retour).
 */
function NotFound() {
    const navigate = useNavigate()

    return (
        <div className="eb-nf">
            {/* Halos décoratifs */}
            <span className="eb-nf-orb o1" />
            <span className="eb-nf-orb o2" />
            <span className="eb-nf-orb o3" />

            <div className="eb-nf-card">
                <span className="eb-nf-badge"><Compass size={14} /> Route introuvable</span>
                <h1 className="eb-nf-code">4<span>0</span>4</h1>
                <h2 className="eb-nf-title">Page indisponible</h2>
                <p className="eb-nf-sub">
                    La page que vous recherchez n'existe pas, a été déplacée
                    ou vous n'y avez pas accès.
                </p>
                <div className="eb-nf-actions">
                    <Link to="/" className="eb-nf-btn primary">
                        <Home size={16} /> Retour à l'accueil
                    </Link>
                    <button className="eb-nf-btn ghost" onClick={() => navigate(-1)}>
                        <ArrowLeft size={16} /> Page précédente
                    </button>
                </div>
            </div>

            <footer className="eb-nf-foot">
                eBCall © 2024 all rights reserved · Provided by IBG-Alpha Technology
            </footer>
        </div>
    )
}

export default NotFound
